import React, { useEffect, useRef, useState } from "react";


import fallback_img from "../../../img/fallback_img.jpg"
import loading_img from "../../../img/loadingImg.jpg"
import ListUIInner from "./ListUIInner";
import RenderBlock from "./RenderBlocks";

const ListUI = ({ setCurrentContentIndex,currentIndex,CurrentObject ,setCurrentObject, setHideReduUnDo, moveItemUp,moveItemDown,deleteItem,duplicateItem,duplicateContentsItem,item ,dynamicId,
    
}) => {
const ImageFallFB = ({ src,width, borderRadius,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true)
             },[ currentIndex]
         )
  return ( 
    <div >
      {!isLoaded && !hasError && (
        <div
         style={
             { width: `${width}%`,
              borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      height: "100%",
      objectFit: "cover",  }}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
              // width:iWidth,
              borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      height: "100%",
      objectFit: "cover",  }}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      height: `${width}%`,
      objectFit: "cover",  }}
      />
    </div>
  );
};


const ImageFallFBLoading = ({ src,width, borderRadius,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
  return (
    <div >
      {(
        <div
         style={
             { 
              borderRadius:`${borderRadius?.value}${borderRadius?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,background:"#444",
      width: `100%`,
      height: "100%",
      objectFit: "cover",  }}
        >
         
        </div>
      )}
      
    </div>
  );
};


  const [itemWidth, setitemWidth] = useState("100%");
                   const columns = CurrentObject?.columns 
                   ;// black / white
                     const scrollItemsLocal= CurrentObject?.scrollItems ;
    const titleFontSizeLocal= CurrentObject?.titleFontSize;
const subtitleFontSizeLocal=  CurrentObject?.subTitleFontSize;
    const titleFontColorLocal=  CurrentObject?.titleFontColor ;
const subTitleFontColorLocal=  CurrentObject?.subTitleFontColor ;
 const titleFontWeightLocal=  CurrentObject?.titleFontWeight ;
const subtitleFontWeightLocal=  CurrentObject?.subTitleFontWeight ;
 const showTitleLocal=  CurrentObject?.showTitle ;
const showSubTitleLocal=  CurrentObject?.showSubTitle;

const aspectRatioLocal=  CurrentObject?.aspectRatio ;
const imarginLeftLocal=  CurrentObject?.imarginLeft ;
const imarginTopLocal=  CurrentObject?.imarginTop ;
const marginLeftLocal=  CurrentObject?.marginLeft;
const marginTopLocal=  CurrentObject?.marginTop ;
const marginBottomLocal=  CurrentObject?.marginBottom ;
const borderRadiusLocal=  CurrentObject?.borderRadius ;
const fontFamilyLocal=  CurrentObject?.fontFamily ;
const textAlignmentLocal=  CurrentObject?.textAlignment ;
const iWidthLocal=  CurrentObject?.iWidth ;
const textPositionLocal=  CurrentObject?.textPosition;
const applyOverlayLocal=  CurrentObject?.applyOverlay ;
const overlayTitleFontColorLocal=  CurrentObject?.overlayTitleFontColor ;
const overlayBGLocal=  CurrentObject?.overlayBG ;
const absoluteHorizontalLocal=  CurrentObject?.absoluteHorizontal ;
const absoluteHorizontalMarginLocal=  CurrentObject?.absoluteHorizontalMargin ;
const absoluteVerticalLocal=  CurrentObject?.absoluteVertical ;
const absoluteVerticalMarginLocal=  CurrentObject?.absoluteVerticalMargin ;
// const overlayLocal= overlay[dynamicId] ;
  const containerRef = useRef(null);
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
const [elementOpacity, setElementOpacity] = useState(0);
const [loadingCards, setLoadingCards] = useState(0);
//text Position
// image overlay
const [imageOverlayColor, setImageOverlayColor] = useState("rgba(144, 202, 249,0.15)");
// On Image Text 
const [overlayTextAlign, setOverlayTextAlign] = useState("bottom");
const [imageOverlayTextColor, setImageOverlayTextColor] = useState("#fff");
const [overlayTextMargin, setoverlayTextMargin] = useState("2%");

  const handleMouseDown = (e) => {
    setIsDown(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDown(false);
  const handleMouseUp = () => setIsDown(false);

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // scroll speed
    containerRef.current.scrollLeft = scrollLeft - walk;
  };



 

 const rows = [];
  for (let i = 0; i < CurrentObject?.images?.length; i += columns) {
    rows.push(CurrentObject?.images?.slice(i, i + columns));
  }

useEffect(()=>{
   setElementOpacity(0.3);setTimeout(()=>{  setElementOpacity(1);},300)
   setLoadingCards(true);setTimeout(()=>{  setLoadingCards(false);},0)
  const div = document.getElementById('ListDivId');
  if (div) {
  const screenWidth = div.getBoundingClientRect().width;

let itemWidth = screenWidth / columns;
setitemWidth(itemWidth);

}
},[itemWidth,columns])



const getTopLevelBlocks = (allBlocks) => {
  const innerKeys = new Set();

  allBlocks?.forEach((block) => {
    block?.innerBlocks?.forEach(inner => {
      if (inner?.myKey) {
        innerKeys.add(inner?.myKey);
      }
    });
  });

  return allBlocks.filter(block => !innerKeys.has(block?.myKey));
};
const RenderContents = ({ contents }) => {
  const topLevelBlocks = getTopLevelBlocks(contents);

  return ( 
    <div>
      {topLevelBlocks.map((block,index) => (   
                   
        <RenderBlock dynamicId={dynamicId} index={index} setCurrentContentIndex={(currentItem)=>{  }} 
         key={block.myKey} block={block} allBlocks={contents}  currentIndex={currentIndex}
    //      
          setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem) ;
            setCurrentContentIndex(parseInt(currentItem?.contentNo)); 
            // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
            }}
          duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}  />
          
      ))}
    </div>
  );
};
  return (<div id="ListDivId" style={{position:"relative",opacity:elementOpacity,}} onClick={()=>{}}>
                        
                          <RenderContents contents={CurrentObject?.contents}
                            />
                        
                          {/* {CurrentObject?.contents?.map((item,index) => ((
                            <div onClick={()=>{setCurrentContentIndex(index)}}>
                    
                    
                  
                       <ListUIInner   
                                    CurrentObject ={item} 
                                    currentIndex={currentIndex} dynamicId={dynamicId} 
                                         setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);
                                          // alert(parseInt(currentItem?.contentNo)+currentItem?.myKey)
                                         }}
                                       
                                         duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}
                                  /> </div>)))} */}
                           
                             </div> );

                             
};


export default ListUI;
